<template>
  <div id="contenedor-listado-mobiles">
    <template v-for="(contrato, index) in listadoContratos">
      <v-card :key="index" class="mb-2">
        <v-card-title class="justify-space-between">
          <div class="d-inline-block text-truncate">
            <router-link class="secondary--text font-weight-bold"
              :to="{ name: 'contrato', params: { idContrato: contrato.id } }">
              {{ contrato.numero }}
            </router-link>
          </div>
          <div class="d-inline-block">
            <opciones :contrato="contrato"> </opciones>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            {{ contrato.meta }}
          </v-row>
          <v-row>
            <v-col>
              <span class="secondary--text font-weight-bold">
                {{contrato.contratista.nombreRazonSocial}}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
